import React, {Component} from 'react';
import {
    IcoChat_A,
    IcoChat_B,
    IcoChat_C,
    IcoChat_D,
    IcoChat_E,
    IcoChat_F,
    IcoChat_A_with_notification
} from '../iconsSvg'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

class ChatMainIcon extends Component {
    state = {
        currentSlide: 0,
        pos: {
            x: document.documentElement.clientWidth - 100,
            y: document.documentElement.clientHeight - 100
        },
        bgArray: [''],
        isInstagram: null,
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        this.changeBackgroundColorOnSlide();
    }

    componentDidUpdate(props, state) {
        if (this.state.dragging && !state.dragging) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        } else if (!this.state.dragging && state.dragging) {
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    onMouseDown = e => {
        if (e.button !== 0) return;

        let pos = document.getElementById("mainIcon");

        this.setState({
            dragging: true,
            rel: {
                x: e.pageX - pos.offsetLeft,
                y: e.pageY - pos.offsetTop
            }
        });
        e.stopPropagation();
        e.preventDefault();
    };

    onMouseUp = e => {
        let mainIcon = this.mainIcon.getBoundingClientRect();
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;

        this.setState({dragging: false});

        if (mainIcon && mainIcon.x < 0) {
            this.setState({
                pos: {x: 5}
            });
        }
        if (mainIcon && mainIcon.right > windowWidth) {
            let positionLeft = windowWidth - this.mainIcon.offsetWidth - 5;
            this.setState({
                pos: {x: positionLeft}
            });
        }
        if (mainIcon && mainIcon.y < 0) {
            this.setState({
                pos: {y: 5}
            });
        }
        if (mainIcon && mainIcon.bottom > windowHeight) {
            let positionBottom = windowHeight - this.mainIcon.offsetHeight - 5;
            this.setState({
                pos: {y: positionBottom}
            });
        }

        e.stopPropagation();
        e.preventDefault();
    };

    onMouseMove = e => {
        if (!this.state.dragging) return;

        this.setState({
            pos: {
                x: e.pageX - this.state.rel.x,
                y: e.pageY - this.state.rel.y
            }
        });
        e.stopPropagation();
        e.preventDefault();
    };

    changeBackgroundColorOnSlide = () => {
        const uniqArr = [{
            name: 'mainIcon',
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_1
        }, {
            name: window.LINK_FACEBOOK,
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_2
        }, {
            name: window.LINK_TELEGRAM,
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_3
        }, {
            name: window.LINK_SKYPE,
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_4
        }, {
            name: window.LINK_VIBER,
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_5
        }, {
            name: window.LINK_INSTAGRAM,
            color: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_6
        }];

        const bgItems = uniqArr.filter(f => f.name).map((item, iter) => {
            if (item.name) {
                return item.color
            }
        });

        this.setState({bgArray: bgItems}, () => {
            if (window.LINK_INSTAGRAM) {
                this.setState({isInstagram: uniqArr.filter(f => f.name).findIndex(i => i.name === window.LINK_INSTAGRAM)})
            }
        })
    }

    resize = () => this.setState({
        pos: {
            x: document.documentElement.clientWidth - 100,
            y: document.documentElement.clientHeight - 100
        }
    });


    render() {
        let {
            handleVisibleChat,
            autoplayMainIcon,
            visibleCounterNewMessage,
            oldCounterHistoryMessage,
            openingChat,
            handleOpeningChat,
        } = this.props;

        const {bgArray, currentSlide, isInstagram} = this.state;

        let chatLanguage = document.getElementById('chatLanguage');
        let lang = chatLanguage.getAttribute('data-language');

        const renderSliderItem = (() => {
            const settings = {
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: autoplayMainIcon,
                autoplaySpeed: 2000,
                swipe: false,
                beforeChange: (current, next) => {
                    this.setState({currentSlide: next})
                }
            };

            return (
                <Slider
                    {...settings}
                >
                    {window.VISIBLE_CHAT_ICON && <div className="sm-chat_slide sm-mainIco-left_1">
                        {window.CHAT_ICON_WITH_NOTIFICATION ? IcoChat_A_with_notification : IcoChat_A}
                        {visibleCounterNewMessage && oldCounterHistoryMessage > 0 &&
                        <span className="sm-counterMessage">{oldCounterHistoryMessage}</span>}
                        {window.CHAT_ICON_WITH_NOTIFICATION &&
                        <div className={`sm-typing ${openingChat ? 'open' : ''}`}>
                            <div className="sm-spinner">
                                <div className="bounce1" style={{backgroundColor: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_1 || '#005BA8'}}/>
                                <div className="bounce2" style={{backgroundColor: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_1 || '#005BA8'}}/>
                                <div className="bounce3" style={{backgroundColor: window.STYLE_MAIN_ICON_BACKGROUND_COLOR_1 || '#005BA8'}}/>
                            </div>
                        </div>}
                    </div>}
                    {window.LINK_FACEBOOK && <div className="sm-mainIco-left_4">{IcoChat_B}</div>}
                    {window.LINK_TELEGRAM && <div className="sm-mainIco-left sm-mainIco-left_2">{IcoChat_C}</div>}
                    {window.LINK_SKYPE && <div className="sm-mainIco-left_5">{IcoChat_D}</div>}
                    {window.LINK_VIBER && <div className="sm-mainIco-left_3">{IcoChat_E}</div>}
                    {window.LINK_INSTAGRAM && <div className="sm-mainIco-left_6">{IcoChat_F}</div>}
                </Slider>
            )
        })();

        return (
            <div
                className={`sm-chat__main__icon ${window.CHAT_ICON_WITH_NOTIFICATION && !openingChat ? 'notification-visible' : ''} ${window.MAIN_ICON_FORM && window.MAIN_ICON_FORM === 'circle' ? '' : 'visible'}`}
                onDoubleClick={() => {
                    if (window.FAST_OPEN_WEB_CHAT) {
                        handleOpeningChat(true)
                    } else {
                        handleVisibleChat(true)
                    }
                }}
                onClick={() => {
                    if (window.CHAT_ICON_WITH_NOTIFICATION) {
                        this.onMouseDown
                    } else {
                        if (window.FAST_OPEN_WEB_CHAT) {
                            handleOpeningChat(true)
                        } else {
                            handleVisibleChat(true)
                        }
                    }
                }}
                onMouseDown={this.onMouseDown}
                id="mainIcon"
                style={{left: this.state.pos.x + 'px', top: this.state.pos.y + 'px'}}
                ref={node => (this.mainIcon = node)}
            >
                <div
                    className={`hexagon ${window.MAIN_ICON_FORM && window.MAIN_ICON_FORM === 'circle' ? 'circle-important' : 'hexagon-important'} ${isInstagram && currentSlide === isInstagram ? 'with_instagram' : ''} smActiveSlide-${currentSlide}`}
                    style={{background: bgArray[currentSlide]}}
                >
                    <span className="hexagon_before" style={{background: bgArray[currentSlide]}}/>
                    {renderSliderItem}
                    <span className="hexagon_after" style={{background: bgArray[currentSlide]}}/>
                </div>
                {window.CHAT_ICON_WITH_NOTIFICATION && !openingChat && <div className="sm-notification">
                        <span className="sm-element" style={{backgroundColor: window.STYLE_NOTIFICATION_ICON_COLOR ? window.STYLE_NOTIFICATION_ICON_COLOR : '#005ba8'}}/><span>
                            {lang !== '' && lang === 'ua' || lang === 'uk' || lang === 'ukr' && window.MAIN_ICON_ANIMATION_UA ? window.MAIN_ICON_ANIMATION_UA : null}
                            {lang !== '' && lang === 'ru' || lang === 'rus' && window.MAIN_ICON_ANIMATION_RU ? window.MAIN_ICON_ANIMATION_RU : null}
                            {lang !== '' && lang === 'en' || lang === 'eng' && window.MAIN_ICON_ANIMATION_EN ? window.MAIN_ICON_ANIMATION_EN : null}
                        </span>
                </div>}
            </div>
        );
    }
}

export default ChatMainIcon;



// WEBPACK FOOTER //
// ./src/components/chatMainIcon/index.js